export const toURL = (url) => new URL(url.includes('://') ? url : `https://${url}`);

export const validateUrl = (urlAsString) => {
  try {
    const url = toURL(urlAsString);
    const valid = ['http:', 'https:'].includes(url.protocol);

    if (!valid) {
      return false;
    }

    return url;
  } catch (e) {
    return false;
  }
};

export const formatDateToISO = (date) => {
  const offsetMs = date.getTimezoneOffset() * 60 * 1000;
  const msLocal = date.getTime() - offsetMs;
  const dateLocal = new Date(msLocal);
  const iso = dateLocal.toISOString();
  const isoLocal = iso.slice(0, 19);
  return isoLocal;
};
